<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3">
<h1 class="tochead">CONTENTS</h1>
</a><h2 class="toc2"><a id="page_3"></a><a href="#/xhtml/04_Introduction">Introduction</a></h2>
<h2 class="toc2"><a href="#/xhtml/05_Timeline">Timeline</a></h2>
<h2 class="toct"><a href="#/xhtml/06_Chapter01"><span class="toc_hang">Chapter 1:</span> Amphibious Operations in Antiquity</a></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample"><span class="toc_hang">Chapter 2:</span> European Colonialism and New Worlds</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="toc_hang">Chapter 3:</span> The Age of Napoleon, and the Rise of New Powers</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="toc_hang">Chapter 4:</span> The American Advanced Base Force Concept, and the Great War of 1914–1918</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="toc_hang">Chapter 5:</span> The Interwar Period and Development of a Modern Doctrine</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample"><span class="toc_hang">Chapter 6:</span> Axis Domination</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample"><span class="toc_hang">Chapter 7:</span> The War in the Pacific</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample"><span class="toc_hang">Chapter 8:</span> Picking at the Edges: North Africa and the Mediterranean</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample"><span class="toc_hang">Chapter 9:</span> Return to Western Europe</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample"><span class="toc_hang">Chapter 10:</span> The Cold War</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample"><span class="toc_hang">Chapter 11:</span> The Post-Cold War Era and the Modern Middle East</span></h2>
<h2 class="toc1"><span href="#/xhtml/17_Epilogue" title="Link target outside of Sample">Epilogue</span></h2>
<h2 class="toc2"><span href="#/xhtml/18_Further" title="Link target outside of Sample">Further Reading</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?272429c7